import React from 'react';
import './Hero.css';
import portfolioData from '../data/portfolio.json';

const Hero = () => {
  const { personalInfo, objective } = portfolioData;

  const handleDownloadResume = () => {
    // Create a link element
    const link = document.createElement('a');
    link.href = '/Satyam_Prakash_Resume.pdf';
    link.download = 'Satyam_Prakash_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-name">{personalInfo.name}</h1>
          <h2 className="hero-title">{personalInfo.title}</h2>
          <p className="hero-subtitle">{personalInfo.subtitle}</p>
          <p className="hero-objective">{objective}</p>
          <div className="hero-cta">
            <a href={`mailto:${personalInfo.email}`} className="btn-primary">
              Get In Touch
            </a>
            <button onClick={handleDownloadResume} className="btn-secondary">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" style={{ marginRight: '8px' }}>
                <path d="M8.5 1a.5.5 0 0 0-1 0v8.793L5.354 7.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.793V1z"/>
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
              </svg>
              Download Resume
            </button>
            <a href="#projects" className="btn-secondary">
              View Projects
            </a>
          </div>
        </div>
        <div className="hero-image">
          <div className="image-wrapper">
            <img 
              src={require('../../docs/' + personalInfo.profileImage)} 
              alt={personalInfo.name}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
